import { render } from "./CategoryOneLayout.vue?vue&type=template&id=e9244c82"
import script from "./CategoryOneLayout.vue?vue&type=script&lang=ts"
export * from "./CategoryOneLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
